import { PlainDate, PlainDateTime } from "@/utils/date.ts";
import { ShortAddress } from "./address.ts";
import { Temporal } from "temporal-polyfill";

export function pathToTrip(path: number[], times: number[][], timeSpentInNodes: number[], distances: number[][]): {
	start: number // node idx
	end: number // node idx
	timeStart: number // minutes
	time: number // minutes
	pause: number // minutes
	timeEnd: number // minutes
	distance: number // meters
}[]
{
	if (!path.length)
		return []

	// if there's only one node, we can't calculate any trips
	if (path.length == 1)
		return []

	let trips = []
	let curTime = 0
	let from = 0
	for (let i = 1; i < path.length; i++)
	{
		let to = path[i]!
		let time = times[from]![to]!
		let distance = distances[from][to]!
		let timeEnd = curTime + time + timeSpentInNodes[to]!
		
		trips.push({
			start: from,
			end: to,
			timeStart: curTime,
			time,
			distance,
			pause: timeSpentInNodes[to]!,
			timeEnd,
		})

		from = to
		curTime = timeEnd
	}

	return trips
}

function metersToMiles(meters: number)
{
	return meters / 1609.34
}

function minutesToDate(startDate: Date, minutes: number)
{
	let date = new Date(startDate)
	date.setMinutes(startDate.getMinutes() + minutes)
	return date
}

function flattenCluster(
	cid: number,
	cluster: ShortAddress[],
	trips: number[][],
	distances: number[][],
	times: number[][],
	timeSpentInNodes: number[],
	startDateTimes: PlainDateTime[]
)
{
	const result: {
		id: string,
		date: PlainDate,
		timeStart: PlainDateTime,
		timeEnd: PlainDateTime,
		startAddress: string,
		endAddress: string,
		mileage: number,
		vehicle: string
	}[] = []

	for (let i = 0; i < trips.length; i++)
	{
		let trip = trips[i]
		let startDateTime = startDateTimes[i]

		let tripResult = pathToTrip(trip, times, timeSpentInNodes, distances)
		for (let segment of tripResult)
		{
			result.push({
				id: `${cid}-${result.length}`,
				date: startDateTime.date,
				timeStart: PlainDateTime.fromMinutes(
					startDateTime.date,
					startDateTime.timeMinutes + segment.timeStart
				),
				timeEnd: PlainDateTime.fromMinutes(
					startDateTime.date,
					startDateTime.timeMinutes + segment.timeEnd
				),
				startAddress: cluster[segment.start].address,
				endAddress: cluster[segment.end].address,
				mileage: metersToMiles(segment.distance),
				vehicle: "default",
			})
		}
	}
	return result
}

export function flattenResults(
	clusters: ShortAddress[][],
	results: number[][][],
	distances: number[][][],
	times: number[][][],
	timeSpentInNodes: number[][],
	startDateTimes: PlainDateTime[]
)
{
	let res = []
	for (let cid = 0; cid < clusters.length; cid++)
	{
		let cluster = clusters[cid]
		let result = results[cid]
		let distance = distances[cid]
		let time = times[cid]
		let timeSpent = timeSpentInNodes[cid]
		res.push(flattenCluster(cid, cluster, result, distance, time, timeSpent, startDateTimes))
	}
	return res
}